if ('IntersectionObserver' in window) {
    const timelineObserver = new IntersectionObserver(
        (entries) => {
            /** @type {HTMLElement | null} */
            const progress = document.querySelector('.timeline-progress');
            if (!progress || progress.getAttribute('data-filled') === 'true') return;

            for (const entry of entries) {
                if (!entry.isIntersecting) continue;

                const nonFutureEvents = document.querySelectorAll('.timeline-event:not(.future)');
                const allEvents = document.querySelectorAll('.timeline-event');

                if (!allEvents.length) return;

                const percentage = (nonFutureEvents.length / allEvents.length) * 100;
                progress.style.height = percentage + '%';
                progress.setAttribute('data-filled', 'true');
                break;
            }
        },
        { threshold: 0.3 }
    );

    document.querySelectorAll('.timeline-event').forEach((el) => {
        timelineObserver.observe(el);
    });
}
